<div class="background">
    <app-toastr [properties]="alertProperties" *ngIf="showAlert"></app-toastr>
    <div class="card">
        <div class="card-content">
            <div class="header" style="padding-top: 10px; padding-bottom: 10px;">
                <img src="assets/images/Logo-Skidd.png" alt="System Logo" class="logo" />
                <!-- <h1>SKIDDO</h1> -->
            </div>

            <div class="tabs" *ngIf="currentView === 'signIn'">
                <button [class.active]="currentView === 'signIn'" (click)="switchTab('signIn')">SIGN IN</button>
            </div>
            <div class="form-container">
                <div class="mt-1" *ngIf="isError && currentView === 'signIn'" style="color: red; text-align: center">{{loginErrorMessage}}</div>
                <ng-container [ngSwitch]="currentView">
                    <form *ngSwitchCase="'signIn'" [formGroup]="signInForm">
                        <label>Email</label>
                        <app-text-field [control]="$any(signInForm.get('email'))" [submitted]="submittedSignInForm"
                            [placeholder]="'Email'" [errorMessage]="'Email is required'"></app-text-field>

                        <label>Password</label>
                        <div class="password-field">
                            <app-text-field [control]="$any(signInForm.get('password'))" [submitted]="submittedSignInForm" [type]="passwordVisible ? 'text' : 'password'"
                                [placeholder]="'Password'" [errorMessage]="'Password is required'"></app-text-field>
                            <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" aria-label="Toggle password visibility">
                                <i [ngClass]="passwordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                            </button>
                        </div>

                        <div class="link-row">
                            <button type="button" class="link-button" (click)="switchToForgot()">Forgot Password?</button>
                        </div>

                        <button type="submit" class="action-btn" (click)="onSignIn()">SIGN IN</button>
                    </form>

                    <form *ngSwitchCase="'forgot'" [formGroup]="forgotPasswordForm">
                        <p class="form-info">
                            Enter the email associated with your account and we'll send instructions to reset your password.
                        </p>
                        <label>Email</label>
                        <app-text-field [control]="$any(forgotPasswordForm.get('email'))" [submitted]="submittedForgotForm"
                            [placeholder]="'Email'" [errorMessage]="'Email is required'"></app-text-field>

                        <button type="submit" class="action-btn" (click)="onForgotPassword()">SEND RESET LINK</button>
                        <button type="button" class="link-button" (click)="switchToSignIn()" style="margin-bottom: 10px;">Back to Sign In</button>
                    </form>

                    <form *ngSwitchCase="'setPassword'" [formGroup]="setPasswordForm">
                        <h2 class="form-title">{{ setPasswordTitle }}</h2>
                        <p class="form-info">
                            {{ setPasswordDescription }}
                        </p>
                        <label style="display: none;">Reset Code</label>
                        <app-text-field style="display: none;" [control]="$any(setPasswordForm.get('token'))" [submitted]="submittedSetPasswordForm"
                            [placeholder]="'Reset Code'" [errorMessage]="'Reset code is required'"></app-text-field>

                        <label>New Password</label>
                        <app-text-field [control]="$any(setPasswordForm.get('password'))" [submitted]="submittedSetPasswordForm" [type]="'password'"
                            [placeholder]="'New Password'" [errorMessage]="'Password is required'"></app-text-field>

                        <label>Confirm Password</label>
                        <app-text-field [control]="$any(setPasswordForm.get('confirmPassword'))" [submitted]="submittedSetPasswordForm" [type]="'password'"
                            [placeholder]="'Confirm Password'" [errorMessage]="'Confirm password is required'"></app-text-field>

                        <div class="error-text" *ngIf="setPasswordForm.errors?.['passwordMismatch'] && submittedSetPasswordForm">
                            Password and confirm password must match.
                        </div>

                        <button type="submit" class="action-btn" (click)="onResetPassword()">{{ setPasswordButtonLabel }}</button>
                        <button type="button" class="link-button" (click)="switchToSignIn()">Back to Sign In</button>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<app-spinner [state]="progressState"></app-spinner>
